(function () {

    'use strict';

    angular.module('iplusjs.utils.adresse', [
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.schluesselWerte',
        'iplusjs.utils.misc',
        'iplusjs.api.cache',
        'iplusjs.exceptionHandler'
    ])
        .service('AdresseUtilsService', AdresseUtilsService);

    AdresseUtilsService.$inject = [
        '$log',
        'lodash',
        '$q',
        '$http',
        'SchluesselWerteUtilsService',
        'MiscUtilsService',
        'AppConfig',
        'ApiCacheService',
        'ExceptionHandlerService'
    ];
    function AdresseUtilsService($log, _, $q, $http, SchluesselWerteUtilsService, MiscUtilsService, AppConfig, ApiCacheService, ExceptionHandlerService) {
        var that = this,
            resultTypes = {
                GEAENDERT: 'GEAENDERT',
                OK: 'OK',
                VORSCHLAEGE: 'VORSCHLAEGE',
                FEHLER: 'FEHLER'
            };

        that.isAdresseVollstaendig = isAdresseVollstaendig;
        that.existsPlz = existsPlz;
        that.checkPlz = checkPlz;
        that.checkAdresse = checkAdresse;
        that.resultTypes = resultTypes;
        that.getVorschlaege = getVorschlaege;
        that.isEqual = isEqual;
        that.getAdressen = getAdressen;
        that.getUniquePostleitzahlen = getUniquePostleitzahlen;
        that.getAdresseByPostleitzahl = getAdresseByPostleitzahl;
        that.getAdressObject = getAdressObject;
        that.getAdresseErrorObject = getAdresseErrorObject;
        that.search = search;
        function isAdresseVollstaendig(adresse, ignoreLand) {
            return MiscUtilsService.isEverythingNotEmpty(adresse.strasse, adresse.postleitzahl, adresse.ort, ignoreLand ? 'NOT_EMPTY' : _.get(adresse, 'land.wert'));
        }
        function existsPlz(plz, land) {
            land = land || {
                wert: 'D'
            };

            if (MiscUtilsService.isEmpty(plz) || (MiscUtilsService.isNotEmpty(plz) && _.get(land, 'wert') !== 'D')) {
                return $q.resolve();
            }

            return checkPlz(plz).then(function (postleitzahlen) {
                if (MiscUtilsService.isEmpty(postleitzahlen)) {
                    return $q.reject('PLZ existiert nicht');
                } else {
                    return $q.resolve(postleitzahlen);
                }
            });
        }
        function checkPlz(plz) {
            return SchluesselWerteUtilsService.fetch('plz', {
                cache: true,
                params: {
                    filter: plz
                }
            }).then(function (postleitzahlen) {
                return postleitzahlen;
            });
        }
        function checkAdresse(adresse) {
            adresse = adresse || {};

            var cacheId = AppConfig.API.services.adresseChecker + JSON.stringify(adresse);

            return existsPlz(adresse.postleitzahl, adresse.land).then(function (postleitzahlen) {
                if (ApiCacheService.isCached(cacheId)) {
                    $log.debug('AdresseUtilsService.checkAdresse CACHE');
                    var cachedCheckedAdresse = ApiCacheService.get(cacheId);

                    handleVorschlagAdresseIdentisch(cachedCheckedAdresse, adresse);

                    return cachedCheckedAdresse;
                } else {
                    return $http.post(AppConfig.API.services.adresseChecker, adresse).then(function (response) {
                        $log.debug('AdresseUtilsService.checkAdresse SUCCESS');
                        var checkedAdresse = response.data;

                        handleVorschlagAdresseIdentisch(checkedAdresse, adresse);

                        ApiCacheService.put(cacheId, checkedAdresse);
                        return checkedAdresse;
                    }).catch(function (response) {
                        $log.debug('AdresseUtilsService.checkAdresse FAILURE');
                        return $q.reject(response.data);
                    });
                }
            });
        }
        function getVorschlaege(checkedAdresse) {
            checkedAdresse = checkedAdresse || {};

            var vorschlaege = [];

            if (MiscUtilsService.isNotEmpty(checkedAdresse.vorschlaege)) {
                vorschlaege = checkedAdresse.vorschlaege;
            } else if (checkedAdresse.result === resultTypes.GEAENDERT) {
                vorschlaege.push(checkedAdresse.adresse);
            }

            return vorschlaege;
        }
        function handleVorschlagAdresseIdentisch(checkedAdresse, inputAdresse) {
            var vorschlaege = getVorschlaege(checkedAdresse) || [];

            if (vorschlaege.length === 1 && isEqual(vorschlaege[0], inputAdresse)) {
                checkedAdresse.result = 'OK';
                checkedAdresse.vorschlaege = [];
            }
        }
        function isEqual(adresse, compareAdresse) {
            return _.isEqualWith(adresse, compareAdresse, function (value, compareValue) {
                return _.every(_.keys(adresse), function (key) {
                    if (key === 'land') {
                        return _.isEqual(_.get(value[key], 'wert'), _.get(compareValue[key], 'wert'));
                    } else if (key === 'imGeschaeftsgebiet') {
                        return true;
                    }

                    return _.isEqual(value[key], compareValue[key]);
                });
            });
        }
        function getAdressen() {
            return $http({
                method: 'GET',
                url: AppConfig.API.services.adressen,
                cache: true
            }).then(function (response) {
                return response.data;
            }).catch(function (error) {
                return [];
            });
        }
        function getUniquePostleitzahlen(adressen) {
            return _.map(_.uniqBy(adressen, function (adresse) {
                return adresse.postleitzahl;
            }), function (adresse) {
                return adresse.postleitzahl;
            });
        }
        function getAdresseByPostleitzahl(adressen, postleitzahl, options) {
            options = options || {};

            var filteredAdressenPostleitzahl = [],
                filteredAdressenType = [];

            if (MiscUtilsService.isAtLeastOneEmpty(adressen, postleitzahl)) {
                return {};
            }

            filteredAdressenPostleitzahl = _.filter(adressen, { postleitzahl: postleitzahl });

            if (filteredAdressenPostleitzahl && filteredAdressenPostleitzahl.length > 1 && options.prioritaet) {
                filteredAdressenType = _.filter(filteredAdressenPostleitzahl, function (adresse) {
                    return _.get(adresse, 'type.typ') === options.prioritaet;
                });
            }

            return getAdressObject(filteredAdressenType[0] || filteredAdressenPostleitzahl[0] || {});
        }
        function getAdressObject(obj, renameKeys) {
            renameKeys = renameKeys || {
                id: 'adressId'
            };

            return _.mapKeys(_.pick(obj, [
                'strasse',
                'postleitzahl',
                'ort',
                'land',
                'id'
            ]), function (value, key) {
                return renameKeys[key] ? renameKeys[key] : key;
            });
        }
        function getAdresseErrorObject(errorObjects) {
            return _.find(errorObjects, function (errorObject) {
                return MiscUtilsService.isNotEmpty(errorObject);
            });
        }

        function search(adresse, type, options) {
            var params = {
                key: '',
                reqId: '',
                user: '',
                password: '',
                country: 'de',
                street: '',
                number: '',
                postalcode: '',
                city: ''
            };

            params.street = _.get(adresse, 'strasse');
            params.number = _.get(adresse, 'hausnummer') || '';
            params.postalcode = _.get(adresse, 'postleitzahl');
            params.city = _.get(adresse, 'ort');

            if (MiscUtilsService.isEverythingEmpty(params.street, params.number, params.postalcode, params.city)) {
                return $q.resolve([]);
            }

            return $http({
                method: 'GET',
                url: AppConfig.API.services.adresseSearch,
                params: params,
                cache: true,
                httpErrorsIgnore: true,
                unexpectedErrorsIgnore: true
            }).then(function (response) {
                var searchResults = _.map(_.get(response.data, 'results'), function (result) {
                        if (MiscUtilsService.isEmpty(result.number)) {
                            result.street = _.trimEnd(result.street) + ' ';
                        }

                        return result;
                    }),
                    returnCodeResults = _.uniqBy(searchResults, 'returncode');

                if (_.size(returnCodeResults) === 1 && returnCodeResults[0].returncode !== '0') {
                    return [];
                }

                if ((type === 'strasse' || type === 'hausnummer') && MiscUtilsService.isNotEmpty(params.street)) {
                    return _.uniqBy(searchResults, function (result) {
                        return _.join(_.compact([result.street, result.number]));
                    });
                } else {
                    return searchResults;
                }
            }).catch(function (response) {
                ExceptionHandlerService.logRemote(new Error('AdresseUtilsService.search Request-Error Response-Status: ' + response.status), false, true);

                return $q.reject(response);
            });
        }
    }

})();
